function csvExport(csvData, fileName) {
  let csvContent = 'data:text/csv;charset=utf-8,';
  csvContent += [
    Object.keys(csvData[0]).join(';'),
    ...csvData.map(item => Object.values(item).join(';')),
  ]
    .join('\n')
    .replace(/(^\[)|(\]$)/gm, '');

  const data = encodeURI(csvContent);
  const link = document.createElement('a');
  link.setAttribute('href', data);
  link.setAttribute('download', fileName);
  link.click();
}

export { csvExport };
